
    <span class="status-circle"
          [matTooltip]="showTooltip ? DomainStatusLabels[status]:''"
          [ngClass]="{
        'status-circle--orange': status === DomainStatus.PENDING,
        'status-circle--green': status === DomainStatus.APPROVED,
        'status-circle--blue': status === DomainStatus.READY,
        'status-circle--red': status === DomainStatus.REJECTED || status===DomainStatus.INACTIVE,
        'status-circle--gray': status === DomainStatus.ARCHIVED}">
      <i class="fas fa-circle"></i>
    </span>
    <span #ref [ngClass]="ref.children.length >0 ?'pl-2':''" class="ml-1"> 
      <ng-content></ng-content>
    </span>

  